import { lazy } from 'react';

const Leads = lazy(() => import('../../admin/leads/AdminLeadsPage'));

const ManagerLeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/leads',
      element: <Leads />,
    },
  ],
};

export default ManagerLeadsConfig;
